import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import Drawer from 'components/Drawer/Drawer'

import styles from './ManagementOpinion.module.sass'
import { useManagementOpinionInfo } from 'hooks/drawers/useManagementOpinionInfo'
import InfoList from 'components/InfoList/InfoList'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

const DrawerHeader = (props) => {
	const { data } = props
	const { id } = data

	return (
		<div className={styles['drawer-header']}>
			<h5>#{id}</h5>
		</div>
	)
}

const ManagementOpinionHeader = (props) => {
	const { i18n } = useGlobal()
	const { managementOpinion } = props

	return (
		<VStack
			justify='space-between'
			gap='xsmall'
			className={styles['header']}
		>
			<h2>{i18n`Management Opinion`}</h2>
			<strong className={styles['status']}>
				{managementOpinion?.isMedicalOpinionResolved
					? i18n`Concluded`
					: i18n`Requested`}
			</strong>
			<small>{i18n`Asked at ${managementOpinion?.creationDate?.shortDateFormat}`}</small>
		</VStack>
	)
}

const ManagementOpinion = (props) => {
	const { handleClose, data } = props
	const { i18n } = useGlobal()

	const { getRequestDetails, getResponseDetails } = useManagementOpinionInfo(
		data,
		i18n
	)

	return (
		<Drawer
			dialogId={'drawer'}
			handleClose={handleClose}
			customHeader={<DrawerHeader data={data} />}
		>
			<div className={styles['root']}>
				<ManagementOpinionHeader data={data} managementOpinion={data} />
				<div className={styles['content']}>
					<section className={styles['info-section']}>
						<div>
							<h4>{i18n`Requested`}</h4>
							<InfoList items={getRequestDetails()} />
						</div>
						{data.isMedicalOpinionResolved ? (
							<div>
								<h4>{i18n`Opinion`}</h4>
								<InfoList items={getResponseDetails()} />
							</div>
						) : null}
					</section>
				</div>
			</div>
		</Drawer>
	)
}

export default ManagementOpinion
